export const ExpandCollapseControls = ({
  onExpandAll,
  onCollapseAll,
  isAllExpanded, // CC-42347: A11Y: Expand All/Collapse All links do not report their active state - quiz results
  isAllCollapsed, // CC-42347: A11Y: Expand All/Collapse All links do not report their active state - quiz results
}) => {
  return (
    <div className="ppQrAll mt-3">
      <button
        type="button"
        className="ppQrExpCollBtnLink ppQrExpCollTxt"
        aria-pressed={isAllExpanded} // CC-42347: A11Y: Expand All/Collapse All links do not report their active state - quiz results
        onClick={onExpandAll}
      >
        Expand All
      </button>

      <span className="ppQrExpPipeLine"> | </span>

      <button
        type="button"
        className="ppQrExpCollBtnLink ppQrExpCollTxt"
        aria-pressed={isAllCollapsed} // CC-42347: A11Y: Expand All/Collapse All links do not report their active state - quiz results
        onClick={onCollapseAll}
      >
        Collapse All
      </button>
    </div>
  );
};